import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { ROMANIAN_COUNTIES } from "@/lib/romanianCounties";
import { validateCuiCnp } from "@/lib/cuiValidation";

interface SellerFormProps {
  sellerName: string;
  sellerCui: string;
  sellerAddress: string;
  sellerCity: string;
  sellerCounty: string;
  onSellerNameChange: (v: string) => void;
  onSellerCuiChange: (v: string) => void;
  onSellerAddressChange: (v: string) => void;
  onSellerCityChange: (v: string) => void;
  onSellerCountyChange: (v: string) => void;
}

const SellerForm = ({
  sellerName, sellerCui, sellerAddress, sellerCity, sellerCounty,
  onSellerNameChange, onSellerCuiChange, onSellerAddressChange, onSellerCityChange, onSellerCountyChange,
}: SellerFormProps) => {
  const cuiValidation = validateCuiCnp(sellerCui);

  return (
    <div className="rounded-xl border border-border bg-card p-5 space-y-4">
      <h3 className="font-heading font-semibold">Furnizor</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label>Denumire</Label>
          <Input value={sellerName} onChange={(e) => onSellerNameChange(e.target.value)} placeholder="Numele firmei" />
        </div>
        <div className="space-y-2">
          <Label>CUI / CIF / CNP</Label>
          <Input
            value={sellerCui}
            onChange={(e) => onSellerCuiChange(e.target.value)}
            placeholder="ex: RO12345678, CIF sau CNP"
            className={!cuiValidation.valid ? "border-destructive focus-visible:ring-destructive" : ""}
          />
          {!cuiValidation.valid && cuiValidation.error && (
            <p className="text-xs text-destructive">{cuiValidation.error}</p>
          )}
          {cuiValidation.valid && cuiValidation.type === "cnp" && sellerCui.trim() && (
            <p className="text-xs text-muted-foreground">Detectat: CNP (persoană fizică)</p>
          )}
          {cuiValidation.valid && cuiValidation.type === "cui" && sellerCui.trim() && (
            <p className="text-xs text-muted-foreground">Detectat: CUI (firmă)</p>
          )}
        </div>
      </div>
      <div className="space-y-2">
        <Label>Adresă (stradă)</Label>
        <Input value={sellerAddress} onChange={(e) => onSellerAddressChange(e.target.value)} placeholder="Str. Exemplu nr. 1" />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label>Oraș</Label>
          <Input value={sellerCity} onChange={(e) => onSellerCityChange(e.target.value)} placeholder="ex: București" />
        </div>
        <div className="space-y-2">
          <Label>Județ</Label>
          <Select value={sellerCounty} onValueChange={onSellerCountyChange}>
            <SelectTrigger>
              <SelectValue placeholder="Selectează județul" />
            </SelectTrigger>
            <SelectContent>
              {ROMANIAN_COUNTIES.map((c) => (
                <SelectItem key={c.code} value={c.code}>
                  {c.name} ({c.code})
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>
    </div>
  );
};

export default SellerForm;
